export const addTimelineSelection = (selection, id) => {
  const ids = Array.isArray(selection)
    ? selection.filter(Boolean)
    : selection ? [selection] : [];
  return ids.includes(id) ? ids : [...ids, id];
}
